/** Logo oficial — colocar el PNG en ecommerce/public/brand/ */
export const BRAND_LOGO_URL = '/brand/logo-alarcom.png';
export const BRAND_LOGO_ALT = 'Grupo Alarcom';

export const CONTACTO = {
  ciudad: 'Chihuahua, Chihuahua',
  direccion: 'Av. Universidad y Arquitectura 913, Medicina, Magisterial Universidad, 31200 Chihuahua, Chih.',
  telefono: '614 440 0040',
  telefonoHref: 'tel:+526144400040',
  email: 'ventas@alarcom.mx',
  maps:
    'https://www.google.com/maps/search/?api=1&query=Av.+Universidad+y+Arquitectura+913,+Magisterial+Universidad,+31200+Chihuahua',
};

export const PAGOS_LOGOS = {
  visa: '/brand/visa.png',
  mastercard: '/brand/masterCard.png',
  amex: '/brand/americanExpress.png',
  carnet: '/brand/carnet.png',
  openpay: '/brand/openpay-o.svg',
};
